import validate from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher_f924d39af8663cb94184647430147332/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher_f924d39af8663cb94184647430147332/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}